import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import { Add as AddIcon, RemoveCircleOutline as RemoveIcon } from '@mui/icons-material';

// Mock data for filter types
const filterTypes = [
  { value: 'temperatura', label: 'Temperatura' },
  // En el futuro se pueden agregar más filtros aquí
  // { value: 'modelo', label: 'Modelo' },
  // { value: 'edad', label: 'Edad' },
];

// Mock data for filter values
const filterValues = {
  temperatura: [
    { value: 'alto', label: 'Alto' },
    { value: 'medio', label: 'Medio' },
    { value: 'bajo', label: 'Bajo' },
  ],
  // En el futuro se pueden agregar más valores aquí
  // modelo: [
  //   { value: 'modelo1', label: 'Modelo 1' },
  // ],
};

export const DynamicFilterNew = ({ filters, setFilters }) => {
  const handleAddFilter = () => {
    setFilters([...filters, { type: '', values: [] }]);
  };

  const handleRemoveFilter = (index) => {
    const newFilters = filters.filter((_, i) => i !== index);
    setFilters(newFilters);
  };

  const handleTypeChange = (index, event) => {
    const newFilters = [...filters];
    newFilters[index] = { type: event.target.value, values: [] };
    setFilters(newFilters);
  };

  const handleValuesChange = (index, event) => {
    const newFilters = [...filters];
    newFilters[index].values = event.target.value;
    setFilters(newFilters);
  };

  const handleRemoveValue = (filterIndex, valueToRemove, event) => {
    event.preventDefault();
    event.stopPropagation();
    const newFilters = [...filters];
    newFilters[filterIndex].values = newFilters[filterIndex].values.filter(
      (val) => val !== valueToRemove
    );
    setFilters(newFilters);
  };

  const getFilterValueLabel = (typeValue, valueValue) => {
    return filterValues[typeValue]?.find((v) => v.value === valueValue)?.label || '';
  };

  return (
    <Box>
      {/* Filas de filtros existentes */}
      {filters.map((filter, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            mb: 2,
          }}
        >
          {/* Select de tipo de filtro */}
          <FormControl size="small" sx={{ flex: 2, minWidth: 0 }}>
            <Box>
              {/* Espacio invisible para alinear con "Selección múltiple" */}
              <Typography
                sx={{
                  fontSize: 12,
                  color: 'transparent',
                  mb: 0.5,
                  fontWeight: 400,
                  height: '16px',
                }}
              >
                &nbsp;
              </Typography>
              <Select
                value={filter.type || ''}
                onChange={(e) => handleTypeChange(index, e)}
                displayEmpty
                sx={{
                  background: '#fff',
                  width: '90%',
                  height: '40px',
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                    '& .MuiSelect-select': {
                      padding: '8px 12px',
                      fontSize: 14,
                      display: 'flex',
                      alignItems: 'center',
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Selecciona un filtro
                </MenuItem>
                {filterTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </FormControl>

          {/* Select de selección múltiple */}
          <FormControl size="small" sx={{ flex: 3, minWidth: 0 }}>
            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  color: '#8a8fa7',
                  mb: 0.5,
                  fontWeight: 400,
                }}
              >
                Selección múltiple
              </Typography>
              <Select
                multiple
                value={filter.values || []}
                onChange={(e) => handleValuesChange(index, e)}
                disabled={!filter.type}
                displayEmpty
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <Typography sx={{ color: '#8a8fa7', fontSize: 14 }}>Selecciona valores</Typography>;
                  }
                  return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={getFilterValueLabel(filter.type, value)}
                          size="small"
                          onDelete={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRemoveValue(index, value, e);
                          }}
                          onMouseDown={(e) => {
                            // Solo detener propagación si es clic en el icono de eliminar
                            const isDeleteIcon = e.target.closest('.MuiChip-deleteIcon') || 
                                               e.target.classList.contains('MuiChip-deleteIcon') ||
                                               (e.target.tagName === 'svg' && e.target.closest('.MuiChip-deleteIcon'));
                            
                            if (isDeleteIcon) {
                              e.preventDefault();
                              e.stopPropagation();
                              handleRemoveValue(index, value, e);
                            }
                            // Si es clic en otra parte del chip, no hacer nada para permitir que el select se abra
                          }}
                          sx={{
                            height: 24,
                            fontSize: 12,
                            backgroundColor: '#e0e4f7',
                            color: '#3451a1',
                            '& .MuiChip-deleteIcon': {
                              fontSize: 16,
                              color: '#3451a1',
                              cursor: 'pointer',
                              '&:hover': {
                                color: '#f44336',
                              },
                            },
                          }}
                        />
                      ))}
                    </Box>
                  );
                }}
                sx={{
                  background: '#fff',
                  width: '90%',
                  minHeight: '40px',
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                    padding: '4px 8px',
                    '& .MuiSelect-select': {
                      padding: '4px 8px',
                      fontSize: 14,
                      minHeight: '32px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                  },
                }}
              >
                {filter.type &&
                  filterValues[filter.type]?.map((value) => (
                    <MenuItem key={value.value} value={value.value}>
                      {value.label}
                    </MenuItem>
                  ))}
              </Select>
            </Box>
          </FormControl>

          {/* Botón para eliminar filtro */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '40px',
              mt: '16px',
            }}
          >
            <IconButton
              onClick={() => handleRemoveFilter(index)}
              sx={{
                color: '#8a8fa7',
                flexShrink: 0,
                width: '40px',
                height: '40px',
                '&:hover': {
                  color: '#f44336',
                  backgroundColor: 'rgba(244, 67, 54, 0.08)',
                },
              }}
            >
              <RemoveIcon />
            </IconButton>
          </Box>
        </Box>
      ))}

      {/* Botón para añadir filtro */}
      <Button
        variant="text"
        onClick={handleAddFilter}
        startIcon={<AddIcon />}
        sx={{
          color: '#222',
          textTransform: 'none',
          fontSize: 14,
          fontWeight: 400,
          padding: '8px 0',
          justifyContent: 'flex-start',
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#3451a1',
          },
          '& .MuiSvgIcon-root': {
            fontSize: 20,
          },
        }}
      >
        Añadir filtro
      </Button>
    </Box>
  );
};
